export default "__VITE_ASSET__4035a467__"